/* ══════════════════════════════════════════════════════════════════
   订阅浮层。**EB.overlay 的调用方**，不自己写浮层 ——
   遮罩、滚动锁、焦点陷阱、Esc、同一时间只允许一个浮层，全在 EB.overlay。

   这个文件真正干的是三件别人不干的事：

     1. 什么时候出现。画得再好，时机不对就只是一次打断。
     2. 出现过之后记住。频次比文案更能决定这东西讨不讨人嫌。
     3. 角落卡 ↔ 模态之间那次 morph 的三个数（FLIP）。

   提交走 fetch，页面不跳走 —— 「我到底订上了没有」是这一刻唯一的问题，
   用一次整页刷新来回答它，人会怀疑刚才那一下有没有点上。
   **没有 JS 时这个浮层根本不出现**（触发器全在这儿），
   所以不需要为无脚本的情况准备一屏「已提交」。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var OVERLAY_ID = 'newsletter-popup';
  var KEY = 'hpx.optin';
  var SESSION_KEY = 'hpx.optin.session';

  var root = document.querySelector('[data-optin]');
  if (!root) return;

  var modal = root.querySelector('[data-optin-modal]');
  var nudge = root.querySelector('[data-optin-nudge]');
  var cfg = JSON.parse(modal.getAttribute('data-optin-config') || '{}');

  var releaseFocus = null;
  var armed = true;
  var opened = false;

  /* ── 记忆 ──────────────────────────────────────────────────────
     一个键，三个字段。用 localStorage 不用 cookie：这不是给服务端读的，
     也不该跟着每一个请求上路。读写都包起来 —— 隐私模式下 Safari 会抛。 */
  function read() {
    try { return JSON.parse(window.localStorage.getItem(KEY)) || {}; }
    catch (e) { return {}; }
  }
  function write(patch) {
    var next = read();
    for (var k in patch) { if (Object.prototype.hasOwnProperty.call(patch, k)) next[k] = patch[k]; }
    try { window.localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) { /* 无所谓 */ }
    return next;
  }
  function sessionSeen() {
    try { return window.sessionStorage.getItem(SESSION_KEY) === '1'; } catch (e) { return false; }
  }
  function markSession() {
    try { window.sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) { /* 无所谓 */ }
  }
  function daysSince(ts) { return ts ? (Date.now() - ts) / 86400000 : Infinity; }

  /* ── 该不该出、出哪一个 ───────────────────────────────────────
       'modal'  第一次（或过了冷却期）
       'nudge'  关掉之后的冷却期内 —— **关掉不等于永远失去这条路**
       null     订过了、这次会话已经出过、或者手里已经有券了
     不出的页面（购物车、结账、账户、试骑页）在 Liquid 那一层就没渲染，
     所以这里看不到它们。 */
  function decide() {
    var s = read();
    if (s.done) return null;
    /* 带着 discount 参数进来的人手里已经有券了，再给一张只会显得我们不看情况 */
    if (/[?&]discount=/.test(window.location.search)) return null;
    if (sessionSeen()) return null;
    if (daysSince(s.dismissedAt) < cfg.dismissDays) return cfg.nudge ? 'nudge' : null;
    return 'modal';
  }

  /* ── 开 / 关 ──────────────────────────────────────────────────
     两块面板是两个真节点，不是同一块的两种 innerHTML —— morph 要同时
     量到「从哪来」和「到哪去」，两个尺寸必须同时存在。 */
  function show(box, opts) {
    box.hidden = false;
    /* **强制回流，不用 rAF。** hidden 和 class 落在同一帧里，浏览器只会看到
       最终值，过渡整个被跳过；一个 rAF 也不保险（同帧会被合并）。读一次
       offsetWidth 逼它先认下「起手式」那一帧，后面的过渡才有起点。 */
    void box.offsetWidth;
    box.classList.add('is-open');
    /* **装在显示之后。** hidden 的元素 clientHeight 是 0，那时候算出来
       「还有下文」永远成立，箭头会挂在一栏根本不滚的内容上。 */
    equipMore();
    if (opts && opts.focus) {
      var panel = box.querySelector('.eb-optin__panel');
      /* 手机上不自动聚焦输入框：键盘一弹，抽屉只剩一条缝。
         成功那一屏也不聚焦 —— 那一屏的输入框在藏着的那半边，
         focus 一个 hidden 的元素等于谁都没聚焦，键盘用户会掉在页面上。 */
      var live = box.querySelector('[data-optin-view="form"]:not([hidden]) input[type="email"]');
      var initial = (window.EB && EB.isMobile()) ? panel : (live || panel);
      releaseFocus = EB.trapFocus(panel, initial);
    }
  }
  function hide(box, then) {
    box.classList.remove('is-open');
    box.classList.add('is-closing');
    if (releaseFocus) { releaseFocus(); releaseFocus = null; }
    window.setTimeout(function () {
      box.classList.remove('is-closing');
      if (!box.classList.contains('is-open')) box.hidden = true;
      if (then) then();
    }, 420);
  }

  /* FLIP：把「从哪来」写成三个变量交给 CSS。
     **传进来的是一个已经量好的 rect，不是节点** —— 角落卡在开窗那一瞬间
     就被藏起来了，等到这里再量，拿到的是一圈 0，morph 会从屏幕左上角
     飞过来。量在藏之前，这是 FLIP 里唯一一处顺序不能换的地方。 */
  function morphFrom(from) {
    if (!from || !from.width) return;
    modal.hidden = false;
    var to = modal.querySelector('.eb-optin__panel').getBoundingClientRect();
    modal.style.setProperty('--from-x', (from.left + from.width / 2 - (to.left + to.width / 2)) + 'px');
    modal.style.setProperty('--from-y', (from.top + from.height / 2 - (to.top + to.height / 2)) + 'px');
    modal.style.setProperty('--from-s', Math.max(0.45, from.width / to.width).toFixed(3));
    modal.classList.add('eb-optin--from-nudge');
  }
  function clearMorph() {
    modal.classList.remove('eb-optin--from-nudge');
    modal.style.removeProperty('--from-x');
    modal.style.removeProperty('--from-y');
    modal.style.removeProperty('--from-s');
  }

  /* ── 登记到 EB.overlay。只有模态登记 ──────────────────────────
     角落卡不是浮层：它不锁滚动、不抢焦点、也不该在打开购物车时被顶掉。
     把它也登记进去，等于宣布「同一时间只能有一个」——
     而它存在的意义恰恰是可以一直在。 */
  if (window.EB && EB.overlay) {
    EB.overlay.register(OVERLAY_ID, {
      onOpen: function (opts) {
        opened = true;
        markSession();
        write({ seen: Date.now() });
        if (opts && opts.from) morphFrom(opts.from);
        show(modal, { focus: true });
      },
      onClose: function (opts) {
        hide(modal, function () {
          clearMorph();
          /* 关掉模态 → 冷却期开始，角落卡接手。成功之后不接手：
             那时候 done 已经写下了，什么都不该再出现。 */
          if (!(opts && opts.silent) && !read().done) {
            write({ dismissedAt: Date.now() });
            if (cfg.nudge) show(nudge);
          }
        });
      }
    });
  }

  function openModal(fromEl) {
    var rect = fromEl ? fromEl.getBoundingClientRect() : null;
    if (nudge) { nudge.classList.remove('is-open'); nudge.hidden = true; }
    EB.overlay.open(OVERLAY_ID, { from: rect });
  }

  /* ── 触发器 ───────────────────────────────────────────────────
     延时 / 滚动 / 退出意图，谁先到算谁。三个都只开一次枪。 */
  function fire() {
    if (!armed || opened) return;
    armed = false;
    var mode = decide();
    if (mode === 'modal') openModal(null);
    else if (mode === 'nudge') { markSession(); show(nudge); }
  }

  function arm() {
    if (cfg.delay > 0) window.setTimeout(fire, cfg.delay * 1000);

    if (cfg.scroll > 0) {
      var onScroll = function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && (window.scrollY / h) * 100 >= cfg.scroll) {
          window.removeEventListener('scroll', onScroll);
          fire();
        }
      };
      window.addEventListener('scroll', window.EB ? EB.throttle(onScroll, 200) : onScroll, { passive: true });
    }

    /* 退出意图**只在桌面**。手机没有指针；用返回手势去劫持它是在偷浏览器的
       后退键，比弹窗本身更招人恨 —— 手机端靠滚动深度兜底就够了。 */
    if (cfg.exitIntent && window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', function (e) {
        if (e.clientY <= 0 && !e.relatedTarget) fire();
      });
    }
  }

  /* Cookie 同意条没关掉之前，计时不开始。
     **两层浮层叠在一起是这个站可能出现的最差的一屏**，而且那一刻人正在
     读一段法律文字，弹窗只会连同意条一起被当成噪音关掉。 */
  function waitForConsent(done) {
    var sel = cfg.cookieSelector;
    if (!sel) return done();
    var gate = function () {
      var banner = document.querySelector(sel);
      return !banner || banner.offsetParent === null;
    };
    if (gate()) return done();
    var timer = window.setInterval(function () {
      if (!gate()) return;
      window.clearInterval(timer);
      done();
    }, 500);
    /* 兜底：同意条一直在（比如访客就是不点），两分钟后放弃等待。
       没有这一条，一个从不点同意的人永远看不到这一屏 —— 那是**默认不出现**，
       不是我们想要的默认。 */
    window.setTimeout(function () { window.clearInterval(timer); done(); }, 120000);
  }

  /* ── 交互 ────────────────────────────────────────────────────── */
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-optin-close]')) {
      var box = e.target.closest('.eb-optin');
      if (box === nudge) {
        /* 关角落卡 = 再按一次冷却。它不是「这次不看」，是「别再推我了」。 */
        write({ dismissedAt: Date.now() });
        hide(nudge);
      } else {
        EB.overlay.close(OVERLAY_ID);
      }
      return;
    }
    /* 点角落卡的**空白处**才开模态。输入框、箭头键、试骑链接各干各的 ——
       角落卡本身就能收邮箱，把整块做成一个「打开大窗」的按钮等于把它废掉。 */
    if (nudge && e.target.closest('[data-optin-nudge] .eb-optin__panel') && !e.target.closest('input, a, button, label')) {
      openModal(nudge.querySelector('.eb-optin__panel'));
    }
  });

  /* ── 提交 ─────────────────────────────────────────────────────
     Shopify 的 customer 表单没有 JSON 接口。fetch 过去之后靠**跟随重定向
     之后的地址**判断成败：成功会被带到 ?customer_posted=true。
     这比去解析返回的整页 HTML 稳 —— 那是主题的 HTML，改个页脚就可能失灵。 */
  function submit(form) {
    var box = form.closest('.eb-optin');
    var btn = form.querySelector('button[type="submit"]');
    var err = form.querySelector('[data-optin-error]');
    if (btn) btn.setAttribute('aria-disabled', 'true');
    if (err) err.hidden = true;

    /* ── 生日**另外**发一份给店铺自有后端 ────────────────────────
       Shopify 的 customer 表单只认固定那几个 `contact[...]`，
       `contact[birthday_month]` 会被**静默丢掉**（提交成功、字段没了）。
       上面那个 `contact[tags]` 的 `bday-MM-DD` 是给 Shopify 客户记录留的；
       这一份是给生日券那条定时流程用的 —— 它读的是店铺自己的库，读不到 tag。

       ⚠ **两件事的主次不能反。** 下面那个 customer 表单是**不能失败**的那个：
         它决定这个人算不算订阅成功。这一份是附带的 —— 不 await、不看结果、
         出错也不显示给客人。生日到了通知邮件却没到库里，是能补的；
         订阅本身被一个超时的 fetch 吞掉，补不回来。
       ⚠ keepalive：万一提交之后页面被导走，这一包也要送得出去。
       ⚠ 没有 data-optin-hook 就整段跳过，表单照常工作。
       ⚠ 这段和 snippets/optin-form.liquid 上那个属性是**一对**，
         少传任何一个都是「属性挂着但没人读」，不报错、也不生效。 */
    try {
      var hook = form.getAttribute('data-optin-hook');
      var em = form.querySelector('[name="contact[email]"]');
      if (hook && em && em.value) {
        var bw = form.querySelector('.eb-optin__bday');
        var bm = bw && bw.querySelector('[data-optin-bday="month"]');
        var bd = bw && bw.querySelector('[data-optin-bday="day"]');
        window.fetch(hook, {
          method: 'POST', keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: em.value,
            birthday_month: bm ? bm.value : '',
            birthday_day: bd ? bd.value : '',
            source: 'popup'
          })
        }).catch(function () {});
      }
    } catch (e) {}

    window.fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'text/html' }
    }).then(function (res) {
      if (res.url && res.url.indexOf('customer_posted=true') > -1) return succeed(box);
      throw new Error('rejected');
    }).catch(function () {
      if (err) err.hidden = false;
    }).then(function () {
      if (btn) btn.removeAttribute('aria-disabled');
    });
  }

  /* 成功之后**就地换脸，不换面板**：面板一换，刚填完的人会以为自己跳到了
     别的地方。从角落卡提交的，把模态开出来告诉他去收件箱 ——
     那句话太重要，不能塞进一张 356 宽的卡里。 */
  function succeed(box) {
    write({ done: true });
    /* 先换脸再开窗：morph 要量「到哪去」，而成功那一屏比表单那屏窄一大截。
       反过来做的话，量到的是表单的尺寸，面板会先长到 880 再缩回 500。 */
    modal.classList.add('is-done');
    modal.classList.remove('eb-optin--split', 'eb-optin--ticket');
    var view = modal.querySelector('[data-optin-view="form"]');
    var done = modal.querySelector('[data-optin-view="done"]');
    if (view) view.hidden = true;
    if (done) done.hidden = false;
    /* 成功那一屏比表单短一大截，箭头该收就收。 */
    equipMore();
    /* 从角落卡填的，把模态开出来说那句「去收件箱」——
       那句话太重要，塞不进一张 356 宽的卡里。 */
    if (box === nudge) openModal(nudge.querySelector('.eb-optin__panel'));
  }

  /* ── 「下面还有」那颗箭头 ────────────────────────────────────
     滚动条藏起来了（理由在 section-popup.css 里），边缘阴影是气氛，
     这一颗才是把话说明白的那个。**点了往下翻八成一屏。**

     **一块面板只做一颗**，挂在面板上不进滚动区：三种形态里同一时间
     只有一栏在滚，而放进滚动区里它会占一行 —— 末尾多出几十像素死空间，
     还会把一个本来正好放得下的面板顶出几像素滚动。

     两个来源一起听：
       scroll           位置变了
       ResizeObserver   高度变了 —— 字体晚一步加载、小字换行数变了、
                        成功态换脸。**这几种都不产生 scroll 事件**，
                        只听 scroll 那颗箭头会留在一栏根本不用滚的内容上。

     scroll 不冒泡，所以在模态上用捕获听一次。 */
  var CHEV = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 9 7 7 7-7"/></svg>';
  var moreBtn = null;
  var ro = null;

  /* 正在滚的那一栏。**只找看得见的那个** —— 成功态换脸之后表单那一栏
     还在 DOM 里，只是 hidden，量它得到的 clientHeight 是 0。 */
  function liveScroller() {
    var els = modal.querySelectorAll('.eb-optin__body, .eb-tk__main, .eb-optin__done');
    for (var i = 0; i < els.length; i++) {
      if (els[i].offsetParent !== null || els[i].clientHeight > 0) return els[i];
    }
    return null;
  }

  function paintMore() {
    var el = liveScroller();
    var more = !!el && el.scrollHeight - el.scrollTop - el.clientHeight > 8;
    modal.classList.toggle('has-more', more);
    if (ro && el && ro.__el !== el) { ro.disconnect(); ro.observe(el); ro.__el = el; }
  }

  function equipMore() {
    if (!moreBtn) {
      moreBtn = document.createElement('button');
      moreBtn.type = 'button';
      moreBtn.className = 'eb-optin__more';
      moreBtn.innerHTML = CHEV;
      /* 读屏器不需要它：键盘 Tab 走到下一个控件，浏览器自己会把那一栏
         滚过去。留在 Tab 序里等于多一个什么都不解决的站点。 */
      moreBtn.setAttribute('aria-hidden', 'true');
      moreBtn.tabIndex = -1;
      moreBtn.addEventListener('click', function () {
        var el = liveScroller();
        if (!el) return;
        /* 翻八成一屏，不翻整屏 —— 留两成，人还看得见刚才读到哪一行。
           **减少动效偏好下不做平滑**：这一下是「带我过去」，
           不是一段值得欣赏的位移。 */
        el.scrollBy({
          top: el.clientHeight * 0.8,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      });
      modal.querySelector('.eb-optin__panel').appendChild(moreBtn);
      if (window.ResizeObserver) ro = new ResizeObserver(paintMore);
    }
    paintMore();
  }

  modal.addEventListener('scroll', paintMore, true);

  /* ── 生日 → 标签 ──────────────────────────────────────────────
     两个下拉自己都不提交（它们没有 name），改一下就把同一张表里那个
     `contact[tags]` 隐藏域改写成 `newsletter,popup,bday-03-15`。

     **每次都从基底重算，不是往后面追加**：改主意从三月换成七月，
     追加的话两个标签都会留在客户身上，然后这个人一年收两次生日券。
     基底第一次读到就记在节点上 —— 读的是当时的 value，晚一步读到的
     就是已经带着 bday 的那一份。

     只选了月份没选日，落 `bday-03`：**宁可存一个粗一点的答案，
     也不能把人已经给出的那一半悄悄扔掉**（发券那头把它当月初处理就行）。

     写在这里不写在 submit() 里，是因为**同一张表可能被提交两次**
     （第一次网络失败）—— 值早就落在 DOM 上，重试自带正确的标签。 */
  var MONTH_DAYS = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  /* 二月给 29 天。**闰年出生的人是真实存在的**，按 28 截等于把他们从
     这个字段里删掉；发券那头遇到 02-29 当天不存在的年份，按 03-01 发就是了。 */
  function trimDays(wrap) {
    var m = wrap.querySelector('[data-optin-bday="month"]');
    var d = wrap.querySelector('[data-optin-bday="day"]');
    if (!m || !d) return;
    var max = m.value ? MONTH_DAYS[parseInt(m.value, 10) - 1] : 31;
    for (var i = 0; i < d.options.length; i++) {
      var opt = d.options[i];
      var day = parseInt(opt.value, 10);
      if (!day) continue;
      /* hidden 管现代浏览器，disabled 兜住剩下的 —— 只写 hidden，
         老一点的 Safari 照样把 2 月 31 日列出来给人选。 */
      opt.hidden = opt.disabled = day > max;
    }
    /* 先选了 31 再改成二月：那个值现在指着一个不存在的日子，清掉。
       留着它比空着更糟 —— 人看见「31」还在，会以为自己已经填好了。 */
    if (parseInt(d.value, 10) > max) d.value = '';
  }

  root.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-optin-bday]');
    if (!sel) return;
    var wrap = sel.closest('.eb-optin__bday');
    var tags = sel.closest('form').querySelector('[data-optin-tags]');
    if (!wrap || !tags) return;

    if (sel.getAttribute('data-optin-bday') === 'month') trimDays(wrap);

    var mm = wrap.querySelector('[data-optin-bday="month"]').value;
    var dd = wrap.querySelector('[data-optin-bday="day"]').value;
    if (!tags.dataset.base) tags.dataset.base = tags.value;
    tags.value = mm
      ? tags.dataset.base + ',bday-' + mm + (dd ? '-' + dd : '')
      : tags.dataset.base;
  });

  root.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-optin-form]');
    if (!form) return;
    e.preventDefault();
    submit(form);
  });

  /* ── 起 ───────────────────────────────────────────────────────
     编辑器里绕开全部频次逻辑直接开着，否则运营改一次文案要等 15 天
     才能再看见它。 */
  if (window.Shopify && window.Shopify.designMode) {
    show(modal, { focus: false });
    document.addEventListener('shopify:section:select', function (e) {
      if (e.target.contains(root)) show(modal, { focus: false });
    });
    return;
  }

  if (decide()) waitForConsent(arm);
})();
